import Guide from '@scripts/guide'
import 'jquery-modal/jquery.modal.min.css'
import '@styles/main.scss'
import PrimaryNavigation from '@scripts/components/primary-navigation'
import BrVideoPlayer from '@scripts/components/br-video-player'
import OffersSwiper from '@scripts/components/offers-swiper'
import initAppearAnim from '@scripts/utils/scroll-motion'

const { DEV } = import.meta.env

/**
 * Enable guide in dev mode
 */
DEV && new Guide().start()

document.addEventListener('DOMContentLoaded', () => {
    const primaryNavigationElem = document.querySelectorAll('.primary-navigation-wrapper')

    if (primaryNavigationElem.length) {
        const primaryNavigation: PrimaryNavigation = new PrimaryNavigation()

        primaryNavigation.start()
    }

    initAppearAnim()
})

// Init video player modal opener
customElements.define('br-video-player', BrVideoPlayer)
// Init video player modal opener
customElements.define('offers-swiper', OffersSwiper)
